import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import emergencyBg1 from '../../assets/img/sidhi/9.png';
import emergencyBg2 from '../../assets/img/sidhi/10.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Emergency = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [emergencyBg1,emergencyBg2 ];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Emergency</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Emergency</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Emergency Department at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Emergency Department at Hitkari Hospital</h3>
                                     <p>The Emergency Department at Hitkari Hospital is dedicated to providing immediate, high-quality medical care for patients with urgent health needs. Our team of experienced emergency physicians, nurses, and support staff are available 24/7 to handle a wide range of medical emergencies. Equipped with advanced technology and resources, we strive to deliver rapid and effective treatment, ensuring the best possible outcomes for our patients.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Scope of Services</h3>
                                      <br />
                                      <p>We offer a broad spectrum of emergency services, including:</p>
                                     <ul>
                                         <li><strong>Trauma Care:</strong> Comprehensive management of injuries resulting from accidents, falls, and other traumatic events.</li>
                                         <li><strong>Cardiac Emergencies:</strong> Rapid assessment and treatment of heart attacks, arrhythmias, and other acute cardiac conditions.</li>
                                        <li><strong>Stroke Care:</strong> Immediate intervention for stroke patients, including thrombolytic therapy and neurocritical care.</li>
                                         <li><strong>Respiratory Emergencies:</strong> Management of acute respiratory distress, including asthma exacerbations and severe infections.</li>
                                          <li><strong>Pediatric Emergencies:</strong> Specialized care for infants and children requiring immediate medical attention.</li>
                                        <li><strong>Surgical Emergencies:</strong> Prompt surgical intervention for conditions requiring immediate operation, such as appendicitis and bowel obstructions.</li>
                                         <li><strong>Poisoning and Overdose:</strong> Rapid assessment and treatment for poisoning, drug overdoses, and toxic exposures.</li>
                                         <li><strong>Infectious Disease Emergencies:</strong> Management of severe infections, sepsis, and other infectious disease emergencies.</li>
                                          <li><strong>Obstetric and Gynecological Emergencies:</strong> Treatment for pregnancy-related complications and other gynecological emergencies.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Advanced Technology</h3>
                                    <br />
                                       <p>At Hitkari Hospital, we leverage cutting-edge technology to enhance our emergency care capabilities, including:</p>
                                       <ul>
                                            <li>State-of-the-art diagnostic imaging, including CT scans, MRI, and ultrasound.</li>
                                           <li>Advanced cardiac monitoring equipment.</li>
                                            <li>Rapid laboratory testing and blood analysis.</li>
                                            <li>Ventilators and other life support systems.</li>
                                            <li>Dedicated trauma bays and resuscitation areas.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Our Approach</h3>
                                    <br />
                                    <p>Our Emergency Department is committed to providing timely, compassionate, and effective care. We understand that emergencies can be stressful and frightening, and we strive to create a calm and supportive environment for our patients and their families. Our team is dedicated to working collaboratively and efficiently to ensure the best possible outcomes.</p>
                                </div>
                                <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital for Emergency Care?</h3>
                                    <ul>
                                         <li><strong>24/7 Availability:</strong> Our Emergency Department is always open to provide immediate medical care.</li>
                                           <li><strong>Experienced Team:</strong> Highly qualified emergency physicians, nurses, and support staff.</li>
                                            <li><strong>Comprehensive Care:</strong> A wide range of services to address diverse emergency conditions.</li>
                                           <li><strong>Rapid Response:</strong> Efficient triage and assessment to prioritize critical cases.</li>
                                            <li><strong>Patient-Centered Approach:</strong> Focused on providing compassionate and personalized care for every patient.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                     <p>At Hitkari Hospital, we are committed to delivering exceptional emergency care with speed, expertise, and compassion. We are here for you during your most critical moments, providing the immediate medical attention you need. Contact us today for immediate medical assistance, and rest assured that you are in capable hands.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Emergency;